import { get } from "ceres/app/helper/get";

export function parseCategoryDiscountRules(rules)
{
    if (!rules)
    {
        return [];
    }

    return rules.split(";").map(entry =>
    {
        const parts = entry.split(":");

        if (parts.length < 2)
        {
            return null;
        }

        const catId = parseInt(parts[0].trim());
        const tiers = parts[1].split(",")
            .map(tier => tier.split("=").map(value => value.trim()))
            .filter(pair => pair.length === 2)
            .map(pair => ({ minQty: parseInt(pair[0]), percent: parseFloat(pair[1]) }))
            .filter(tier => tier.minQty > 0 && tier.percent > 0)
            .sort((a, b) => a.minQty - b.minQty);

        return (catId > 0 && tiers.length) ? { catId, tiers } : null;
    }).filter(Boolean);
}

export function categoryIdsOf(itemData)
{
    const ids = [
        ...(get(itemData, "ids.categories.all") || []),
        ...(get(itemData, "defaultCategories") || []).map(category => category.id)
    ];

    return ids.map(id => parseInt(id)).filter(id => id > 0);
}
